// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class NotificationSettings {
  readonly userId: string;
  readonly notificationType: Enums.NotificationType;
  readonly allNotifications: boolean;
  readonly quoteStatusChange: boolean;
  readonly approvalRequests: boolean;
  readonly activities: boolean;
  readonly emailReminders: boolean;
  readonly pushReminders: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.userId = data.userId === undefined ? NIL_UUID : data.userId;
    this.notificationType =
      data.notificationType === undefined
        ? Enums.NotificationType.PushNotification
        : data.notificationType;
    this.allNotifications = data.allNotifications === undefined ? false : data.allNotifications;
    this.quoteStatusChange = data.quoteStatusChange === undefined ? false : data.quoteStatusChange;
    this.approvalRequests = data.approvalRequests === undefined ? false : data.approvalRequests;
    this.activities = data.activities === undefined ? false : data.activities;
    this.emailReminders = data.emailReminders === undefined ? false : data.emailReminders;
    this.pushReminders = data.pushReminders === undefined ? false : data.pushReminders;
  }

  static zero(): NotificationSettings {
    const zeroValues: ExcludeMethodsDeep<NotificationSettings> = {
      userId: NIL_UUID,
      notificationType: Enums.NotificationType.PushNotification,
      allNotifications: false,
      quoteStatusChange: false,
      approvalRequests: false,
      activities: false,
      emailReminders: false,
      pushReminders: false,
    };
    return new NotificationSettings(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type NotificationSettingsWireFormat = {
  userId: string;
  notificationType: string;
  allNotifications: boolean;
  quoteStatusChange: boolean;
  approvalRequests: boolean;
  activities: boolean;
  emailReminders: boolean;
  pushReminders: boolean;
};

type NewNotificationSettingsProps = PartialDeep<NotificationSettings, { recurseIntoArrays: true }>;
export const NewNotificationSettings: (
  props: NewNotificationSettingsProps,
) => NotificationSettings = (props) => new NotificationSettings(props);

type NewNotificationSettingsFromWireFormatProps = PartialDeep<
  NotificationSettingsWireFormat,
  { recurseIntoArrays: true }
>;
export const NewNotificationSettingsFromWireFormat: (
  props: NewNotificationSettingsFromWireFormatProps,
) => NotificationSettings = (props) => new NotificationSettings(props);
